import backgroundParticles from "@/assets/images/headerBackgroundParticle.svg";
import { PercentageSymbol } from "@/utils/miscIcons";
import s from "@/components/Header/Header.module.scss";

const root = window?.post_template?.checkout_v6_header;
const logo = root.checkout_v6_header_globalLogo ? window.general_settings.logo : root.checkout_v6_header_customLogo;
const backgroundColor = root.checkout_v6_header_background;
const borderColor = root.checkout_v6_header_borderColor;
const saleLabel = window?.post_template?.tr_header_summer_sale_label;
const upToLabel = window?.post_template?.tr_header_up_to_label;
const pecentOffLabel = window?.post_template?.header_percentage_off_label;
const showBgImage = root.checkout_v6_header_use_bg_img;
const customBgImage = root.checkout_v6_header_bg_img;
const bgImageType = root.checkout_v6_bg_img_type;
const bgImage = customBgImage && bgImageType === "custom_img" ? customBgImage : backgroundParticles;

const Header = ({ isMobile }) => {
  return (
    <header
      className={s.topLine__header}
      style={{
        background: backgroundColor,
        borderColor: borderColor,
      }}
    >
      {showBgImage && <img src={bgImage} alt="Particles" className={s.topLine__headerBg} aria-hidden="true" />}
      <div className={s.topLine}>
        <img className={s.topLine__logo} src={logo} alt={window.general_settings.brand_name} height="24" width="124" />
        {isMobile && <div className={s.topLine__separator}></div>}
        <div className={s.topLine__itemsLeft}>
          <a
            style={{ cursor: "pointer" }}
            onClick={() => {
              const element = document.querySelector("#products");
              element.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });
            }}
          ></a>
        </div>
        <div className={s.topLine__itemsRight}>
          <PercentageSymbol />
          <p className={s["topLine__itemsRight--paragraph"]}>
            {saleLabel} <span className={s["topLine__itemsRight--spanLight"]}>{upToLabel}</span>{" "}
            <span className={s["topLine__itemsRight--spanBold"]}> {pecentOffLabel}</span>
          </p>
        </div>
      </div>
    </header>
  );
};

export default Header;
